module.exports = __webpack_public_path__ + "static/media/mall-discount-bg-green.ff1da353.svg";